'use strict';

var layouts = {},
    contentBoardApi = require('magcore-plugin-content-board'),
    staticLayout = require('./static');


layouts[undefined] = require('./static');
layouts[contentBoardApi.layouts.tvChannel] = require('./tv.channel');
layouts[contentBoardApi.layouts.video] = require('./video');
// layouts[contentBoardApi.layouts.audio] = static.square;

layouts[contentBoardApi.layouts.static] = {};
layouts[contentBoardApi.layouts.static][contentBoardApi.geometry.square] = staticLayout.square;
layouts[contentBoardApi.layouts.static][contentBoardApi.geometry.horizontal] = staticLayout.rectangle;

layouts[contentBoardApi.layouts.record] = require('./record');
layouts[contentBoardApi.layouts.application] = require('./application');

module.exports = layouts;
